import { useEffect } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import { AuthHelpers } from "../utils/auth.helpers";
import { clientRoutes } from "../utils/routes";
import { isAgency } from "../utils/helpers/common";
import { CommonEnums } from "../enums/common.enums";
import { LocalStorageHelpers } from "../utils/helpers/localstorage.helpers";

const ProtectedComponent = ({ children }: { children: any }) => {
  const isLoggedIn = AuthHelpers?.validateAccessToken();
  const navigate = useNavigate();
  let params = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const pathname = location.pathname;
  const eventId = params?.event_id;
  let pathnameArray = location?.pathname?.split("/");
  //   let loginCheck = pathnameArray[3];
  // const expertGetApiHandler = async () => {
  //   const res = await ProfileApi.GetExpertById(expert_id)
  //   if (res?.data?.data?.verified) {
  //     setVerified(true)
  //   }
  // }

  // React.useEffect(() => {
  //   if (accessToken) {
  //     var decoded: Token = jwtDecode(accessToken);
  //     if (!decoded?.verified) {
  //       navigate("/login", { state: { redirect: location?.pathname } });
  //     }
  //   } else {
  //     navigate("/login", { state: { redirect: location?.pathname } });
  //   }
  // }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      if (pathname !== clientRoutes.login) {
        navigate(clientRoutes.login);
      }
      return;
    }

    const agencyInfo: any = LocalStorageHelpers.getAgencyData?.();
    const agentInfo: any = LocalStorageHelpers.getAgentData?.();
    const registrationStatus =
      agencyInfo?.registration_status || agentInfo?.registration_status;

    const isRegistrationComplete =
      registrationStatus === CommonEnums.agentRegistrationStatus.completed;

    if (pathname === clientRoutes.home && !isRegistrationComplete) {
      navigate(clientRoutes.login);
      return;
    }

    let type = searchParams.get("type");

    if (pathname.includes("agent-joining-requests")) {
      if (!isAgency()) {
        navigate(-1);
      }
    }
    if (
      pathname.includes("agents") &&
      type === CommonEnums?.agentsTabsType?.permissions?.key
    ) {
      if (!isAgency()) {
        navigate(-1);
      }
    }
  }, [isLoggedIn, pathname, navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [params]);

  if (!isLoggedIn) {
    return null;
  }

  return <div className="protected-route">{children}</div>;
};

export default ProtectedComponent;